import { createExtensionPoint } from '@interhyp/platform-plugin';
export const headerIconActionExtension = createExtensionPoint(Symbol('header-icon-action'), true);
